import { useEffect, useState, useRef } from "react";
import { Spin, Tag, Typography, Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import axiosInstance from "../api/axiosInstance";

const { Title, Paragraph } = Typography;

const FamilyFun = () => {
  const [toursPackage, setToursPackage] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const carouselRef = useRef(null);

  useEffect(() => {
    const fetchTours = async () => {
      try {
        const res = await axiosInstance.get(
          `/product-details?filters[product_groups][name][$eq]=Family%20fun&populate[Tour_overview][populate]=itinerary_stop&populate[itinerary][populate][Days][populate][image][fields]=id,url,name,alternativeText,caption&populate[itinerary][populate][Days][populate][transfer_info][populate][vehicle_image][fields]=id,url,name,alternativeText,caption&populate[itinerary][populate][Days][populate][hotel_info][populate][hotel_image][fields]=id,url,name,alternativeText,caption&populate[itinerary][populate][Days][populate][departure_pricing]=*&populate[itinerary][populate][Days][populate][activity][populate][activity_image][fields]=id,url,name,alternativeText,caption&populate[booking_info][populate]=travellers&populate[FAQ][populate]=*&populate[Gallery][populate][images][fields]=id,url,name,alternativeText,caption&populate[sections][populate]=*&populate[review_section][populate][reviews][populate][review_image][fields]=id,url,name,alternativeText,caption&populate[review_section][populate][reviews][populate][reviewer_image][fields]=id,url,name,alternativeText,caption&populate[review_section][populate][rating_levels]=*&populate[images][fields]=id,url,name,alternativeText,caption&populate[product_groups][fields]=id,name`,
        );

        setToursPackage(res.data.data || []);
      } catch (error) {
        console.error("Error fetching Travelers' Favorite Choices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTours();
  }, []);

  if (loading)
    return (
      <div className="flex justify-center py-10">
        <Spin size="large" tip="Loading Travelers’ Favorite Choices..." />
      </div>
    );

  return (
    <div className="container custom-carousel">
      {/* Header */}
      <div className="mb-6 font-medium">
        <Title className="!font-medium !text-danger !text-2xl !mb-1" level={2}>
          <span className="text-primary">Family </span> Fun
        </Title>
        <Paragraph className="!mb-0">
          Culture, nature, thrills, and record-breaking experiences
        </Paragraph>
      </div>

      {/* CAROUSEL WRAPPER */}
      <div className="relative">
        {/* LEFT */}
        <button
          onClick={() => carouselRef.current.prev()}
          className="absolute left-0 lg:-left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:scale-110 transition"
        >
          <LeftOutlined />
        </button>

        {/* RIGHT */}
        <button
          onClick={() => carouselRef.current.next()}
          className="absolute right-0 lg:-right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:scale-110 transition"
        >
          <RightOutlined />
        </button>

        {/* CAROUSEL */}
        <Carousel
          ref={carouselRef}
          dots={false}
          infinite={false}
          slidesToShow={4}
          slidesToScroll={1}
          responsive={[
            {
              breakpoint: 1024,
              settings: { slidesToShow: 3 },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 480,
              settings: { slidesToShow: 1 },
            },
          ]}
        >
          {toursPackage.map((tour) => {
            const title =
              tour.title || tour.attributes?.title || "Untitled Tour";
            const slug = tour.slug || tour.attributes?.slug || "tour";
            const parentSlug =
              tour.sub_product?.products?.[0]?.slug || "not-found";
            const subSlug =
              tour.sub_product?.slug ||
              tour.attributes?.sub_product?.data?.attributes?.slug ||
              "subtour";

            const type = tour.type;
            const final_price = tour.final_price;
            const old_price = tour.old_price;
            const save_price = tour.save_price;
            const duration = tour.duration;
            const imageUrl =
              tour.images?.[0]?.url ||
              tour.attributes?.images?.data?.[0]?.attributes?.url ||
              "https://via.placeholder.com/400x250?text=No+Image";

            return (
              <div key={tour.id} className="px-2 h-full">
                <div
                  onClick={() => navigate(`/${subSlug}/${slug}`)}
                  className="bg-white rounded-xl overflow-hidden relative shadow-lg hover:shadow-2xl h-full"
                >
                  <div className="relative cursor-pointer">
                    <div className="absolute bg-black/20 w-full h-full">
                      <div className="absolute bottom-0 p-4 text-white">
                        <div className="text-base font-semibold">
                          AED {final_price}
                        </div>
                        <div className="line-through text-sm">
                          AED {old_price}
                        </div>
                        <div className="text-sm">AED {save_price}</div>
                      </div>
                    </div>

                    <img
                      src={`${process.env.REACT_APP_API_URL}${imageUrl}`}
                      alt={title}
                      className="w-full h-[170px] object-cover"
                    />
                  </div>

                  <div className="p-4 flex flex-col flex-grow">
                    <div className="text-[11px] mb-2">
                      Tour Type
                      <Tag className="ml-2">{type}</Tag>
                    </div>

                    <div className="font-medium text-md line-clamp-2">
                      {title}
                    </div>

                    <div className="text-primary font-medium mt-2">
                      {duration}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default FamilyFun;
